/**
 * Shared formatting utilities for trading data display.
 * Prevents floating-point display bugs across the application.
 */

/** Adaptive quantity formatting based on magnitude */
export const formatQty = (qty: number): string => {
  const n = Math.abs(Number(qty));
  if (n >= 1) return Number(qty).toFixed(2);
  if (n >= 0.01) return Number(qty).toFixed(4);
  return Number(qty).toFixed(6);
};

/** Adaptive price formatting: 2dp for >=100, 4dp for >=1, 6dp for smaller */
export const formatPrice = (price: number): string => {
  const n = Math.abs(Number(price));
  if (n >= 100) return Number(price).toFixed(2);
  if (n >= 1) return Number(price).toFixed(4);
  return Number(price).toFixed(6);
};

/** PnL formatting with +$/−$ prefix, always 2 decimals */
export const formatPnl = (pnl: number): string => {
  const prefix = pnl >= 0 ? '+$' : '-$';
  return `${prefix}${Math.abs(pnl).toFixed(2)}`;
};

/** Compact relative time display */
export const formatTimeAgo = (dateStr: string): string => {
  const now = Date.now();
  const then = new Date(dateStr).getTime();
  const diffMs = now - then;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHrs = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMin < 1) return 'now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHrs < 24) return `${diffHrs}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  const d = new Date(dateStr);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[d.getMonth()]} ${d.getDate()}`;
};
